<template>
  <div class="contactview">
    <!-- <h1>This is the Contact page</h1> -->

    <!-- <div class="myheaderbar">
      <h1>KONTACTY</h1>
    </div> -->

    <div class="columns is-gapless">
      <div class="column is-one-quarter">
        
        <div class="myheaderbar">
          <h1>KONTACTY</h1>
        </div>

        <!-- <div style="padding: 1em; font-size:0.8em;">Selected Contact: <b>{{this.selectedContact.name}}</b></div> -->

        <div style="margin: 1em;">
          <!-- <ListPanel :contactdata="contacts" :selectedcontact="selectedcontact" /> -->
          <!-- <ListPanel :contactdata="contactdata.contacts" v-model="selectedcontact" /> -->
          <!-- <ListPanel selectedcontact={}} /> -->
          <!-- <ListPanel :selecedContact="selectedContact" v-model="selectedContact" /> -->
          

          <template>
            <b-tabs type="is-toggle" expanded>
                
                <b-tab-item label="All" icon="library-music">
                  <ListPanel />         
                </b-tab-item>

                <b-tab-item label="Filter" icon="google-photos">
                  <ListPanelFilter/>  
                </b-tab-item>
                
            </b-tabs>
          </template>
          
        </div>

      </div>

      <div class="column is-one-third">

        <div class="myheaderbar">
          <h1>TRŽBY</h1>
        </div>

        <div style="margin: 0em;">
        
          <div>
            <a class="button is-light"  @click="addContact">
              <div>  
                <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
              </div>
              NEW Contact
            </a>

            <a class="button is-light"  @click="$router.push('/main/googlecontact')">
              <div>  
                <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
              </div>
              Google Sync
            </a>
          </div>

          <!-- <Classification :initSelectedContact="localSelectedContact" v-model="localSelectedContact"/> -->
          <!-- <Classification/> -->
          <Classification :localSelectedContact="localSelectedContact" v-model="localSelectedContact"/> 
        
        </div>

      </div>

      <div class="column ">

        <div class="myheaderbar">
          <h1>KANÁLY</h1>
        </div>
        
        <div style="margin: 0em;">

          <!-- <div v-if="this.localSelectedContact">
            <a class="button is-light"  @click="addChannel">
              <div>  
                <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
              </div>
              NEW Channel
            </a>
          </div> -->

          <ListPanelChannel :localSelectedContact="localSelectedContact" v-model="localSelectedContact" />
          <!-- <ListPanelChannel  :channels="selectedContact.channels" v-model="selectedContact.channels"/> -->
          <!-- <ListPanelChannel/> -->
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  // https://jsfiddle.net/j6tqyt97/4/

  import ListPanel from '@/components/main/contact/ListPanel.vue';
  import ListPanelFilter from '@/components/main/contact/ListPanelFilter.vue';
  // import ListPanelChannel from '@/components/main/contact/ListPanelChannel.vue';
  // import Classification from '@/components/main/contact/Classification.vue';
  import Classification from '@/components/main/contact/Classification.vue';
  import ListPanelChannel from '@/components/main/contact/ListPanelChannel.vue'
  // import Calendar from '@/components/main/contact/Calendar.vue';
  import { mapGetters, mapActions } from 'vuex';


  export default {
    components: {
      ListPanel,
      ListPanelFilter,
      ListPanelChannel,
      // TestListPanelChannel,
      Classification,
      // TestClassification,
      // Calendar
      },
      data() {
        return  {
          // contactdata: {},
          // selectedContact: {}
          localSelectedContact: null,
        }
      },
      created () {
        this.localSelectedContact = this.selectedContact
      },
      computed: {
        ...mapGetters(['selectedContact'])
      },
      methods: {
        ...mapActions(['addNewContact', 'putSelectedContact']),
        addContact () {
          this.localSelectedContact =
            {id:null, firstname: 'New Contact', name:'', channels: [],
                  status: {custtotal: 0, custvalue: '', custrel: '', custclass: '', lastcontact: ''},
                }
          this.addNewContact(this.localSelectedContact)
          this.putSelectedContact(this.localSelectedContact)
        },
        addChannel () {
          this.localSelectedContact.channels.unshift(
            {type: null, info: '', atags: [], tags: [], pref: false} 
            )
        }
      },
      watch: {
        // selectedContact (newValue, oldValue) {
        selectedContact (newValue) {
          // console.log(`Updating from ${oldValue} to ${newValue}`);
          // console.log(`Updating  ${JSON.stringify(newValue)}`);
          this.localSelectedContact = JSON.parse(JSON.stringify(newValue))  //..making a copy (by parsing JSON )
          // this.localSelectedContact = Object.assign({}, newValue)   //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!???
        }
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
</style>
